import { useLang } from "../../lib/i18n";
import { DailyChart } from "./DailyChart";
import { Devices, TopLinks } from "./Breakdowns";

const Tile = ({ label, value, testId, accent }) => (
  <div className="rounded-3xl border border-slate-200/80 bg-white p-5" data-testid={testId}>
    <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{label}</p>
    <p className={`mt-2 font-display text-3xl font-extrabold tracking-tight sm:text-4xl ${accent || "text-slate-900"}`}>{value}</p>
  </div>
);

export const InsightsView = ({ data }) => {
  const { t } = useLang();
  const s = data.totals;
  const rate = s.views ? Math.round((s.saves / s.views) * 100) : 0;
  const tiles = [
    ["views", t("ins_views"), s.views], ["qr", t("ins_qr"), s.qr_scans], ["visitors", t("ins_visitors"), s.unique_visitors],
    ["saves", t("ins_saves"), s.saves], ["save-rate", t("ins_save_rate"), `${rate}%`],
    ["clicks", t("ins_clicks"), s.clicks],
  ];
  const empty = !s.views && !s.saves && !s.clicks;

  return (
    <div className="space-y-5" data-testid="insights-view">
      {empty && <p className="rounded-2xl bg-slate-100 px-4 py-3 text-sm text-slate-600" data-testid="insights-empty">{t("ins_empty")}</p>}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
        {tiles.map(([id, label, value]) => (
          <Tile key={id} label={label} value={value} testId={`insight-${id}`} accent={id === "save-rate" ? "text-2049" : undefined} />
        ))}
      </div>
      <DailyChart daily={data.daily} />
      <div className="grid gap-5 md:grid-cols-2">
        <TopLinks links={data.top_links} />
        <Devices devices={data.devices} />
      </div>
    </div>
  );
};
